import React from "react";
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });

//配置项
let componentName = 'classStudentManagement';

const columns = (data) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
      searchItem: {}
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
      },
      searchItem: {}
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {
        width: 150,
      }
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {
        width: 120,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "扫码入班时间",
      name: "scanCreateTime",
      tableItem: {
        width: 170,
      }
    },
    {
      title: "扫码地址",
      name: "location",
      tableItem: {
        width: 200,
      }
    },
    {
      title: "创建人",
      name: "lecturers",
      searchItem: {
        diy: WizTableForm,
        title: '选择讲师',
        ...userConfig,
      }
    },
    {
      title: "创建人",
      name: "lecturerName",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "创建时间",
      name: "qrCreateTime",
      tableItem: {
        width: 170,
      }
    },
    {
      title: "创建地址",
      name: "lecturerLocation",
      tableItem: {
        width: 200,
      }
    },
  ]
}


const templateConfig = (data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['exportStudents'],
          buttons: [
            {
              key: "exportStudents",
              custom: true,
              params: {icon: 'export', children: '导出学员', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "exportPerson",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: [],
        rowOperateView: [
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {classInfoId} = data;
  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@getListByPage`,
        apiParams: {pageNum: 1, pageSize: 10, classInfoId, classStudentSource: 2}
      }
    },
    exportPerson: {
      path: `${componentName}/exportPerson`,
      payload: {
        key: `${componentName}@exportPerson`,
        apiParams: {classInfoId, classStudentSource: 2}
      }
    },
  }
};


let reduxTemplateConfig = (args) => {
  const {classInfoId} = args;
  return {
    apis: apis({classInfoId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
